import React, { Component, Fragment } from "react"
import moment from "moment"

//services
import { UtilityService } from "../../services"

export default class PrintSmv extends Component {
  state = {
    technicalData: {}
  }

  componentWillMount() {
    const { technicalData } = this.props
    this.setState({
      technicalData
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.technicalData != this.props.technicalData) {
      this.setState({
        technicalData: nextProps.technicalData
      })
      //   this.calculateTotal()
    }
  }
  render() {
    const { technicalData } = this.state

    return (
      <Fragment>
        <div className="fabricPrintDiv">
          <style>
            {`@media print {
                body{
                    font-family: 'Montserrat', sans-serif;
                    font-size:12px;
                }
                .fabricPrintDiv{
                    border : 2px solid black;
                    top : 0;
                    bottom : 0;
                }

                .printrow {

                    width: 100%;
                }

                .centerTextOnly {
                  text-align:left;
                  margin: 20px 10px ;
                  padding: 20px 10px;
                  white-space: pre-line;
                }
                .printcolumn {
                    display: flex;
                    flex-direction: column;
                    flex-basis: 100%;
                    flex: 1;
                }
                table>tbody>tr td{
                    font-size:12px;
                    text-align:center;
                }
                .label-text{
                    color:#279588;
                    font-size : 12px;
                    font-weight:bold;
                }
                .blue{
                    color : #146FF9;
                }
                .padding-for-heading{
                    padding: 5px;
                }


                .specialComments{
                    width: 75%;
                    border : 1px solid black;
                    height : 60px;
                    margin: 10px;
                }

                .b{
                    border: 1px solid black;
                    margin: 10px;
                    padding: 5px;
                }
                .fabric-text{
                    font-size:16px;
                    color: #279588;
                    font-weight: 1000;
                }

                .bold{
                    font-weight:bold;
                }
                .bb-p{
                    border-bottom: 1px solid black;
                    margin-bottom: 10px ;
                }
                .w-50 {
                    width: 50%;
                }
                table.grid{
                    border-collapse: collapse;
                    margin-right: 5px;
                    margin-left: 5px;
                }
                table.grid>tbody>tr td {
                    border: 0.5px solid black;
                    text-align: center;
                    padding: 2px;
                }
                .width-for-table{
                    width: 50%;
                }
                .text-center{
                    text-align: center;
                }
                .p-1{
                    padding : 5px;
                }
                .pl-1{
                    padding-left: 23px;
                }
                .border-bot{
                    border-bottom : 1px solid black;
                }
                .mt{
                    margin-top:10px;
                }
                .mtl{
                    margin-top:30px;
                }
                .margin{
                    margin : 5px;
                }
                .pl-2{
                    padding: 5px;
                }
                .table-heading{
                    padding-left:5px;
                    margin:0;
                    color:#4285f4;
                    text-transform:uppercase;

                }

                .text-capitalize{
                    text-transform: capitalize;
                }

                .padding-option{
                    padding:0px 20px 0px 20px;

                }
                .paddingleft{
                    padding-left:25px !important;
                }
                table{
                    width:100%;
                }
                .test-class{
                    width:40%;

                    display:inline-block
                }
                .test-class1{
                    width:20%;
                    display:inline-block
                }
                .test-class2{
                    width:40%;
                    display:inline-block
                }

                .float-left{
                    float:left !important;
                }
                .text-right{
                    text-align:right !important;
                }
                .text-left{
                    text-align:left !important;
                }
                .padding-top-align{
                    padding-top:15px !important;
                }
                }`}
          </style>
          <div className="bold text-center p-1 ">Technical Issues</div>
          <div className="printrow bb-p">
            <div className="text-capitalize">
              {/* SMV/OB TABLE START */}
              <table>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <tbody>
                  <tr>
                    <td className="label-text">style no</td>
                    <td className="label-text">Style Ref No</td>
                    <td className="label-text">Style Name</td>
                    <td className="label-text">Created Date</td>
                    <td className="label-text">Chart Prepared By</td>
                  </tr>
                  <tr>
                    <td className="bold">{technicalData.styleNumber}</td>
                    <td className="bold">{technicalData.styleReferenceCode}</td>
                    <td className="bold">{technicalData.magnumStyleName}</td>

                    <td className="bold">{technicalData.createdAt}</td>
                    <td className="bold">{technicalData.createdBy}</td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td className="label-text">Customer & Department</td>
                    <td className="label-text">Sample Type</td>
                    <td className="label-text">Date</td>
                    <td className="label-text">Who Attended Meeting</td>
                  </tr>
                  <tr>
                    <td className="bold">{`${technicalData.customerName}/${technicalData.departmentName}`}</td>
                    <td className="bold">{technicalData.sampleType}</td>
                    <td className="bold">{technicalData.date}</td>
                    <td className="bold">{technicalData.attendees}</td>
                  </tr>
                </tbody>
              </table>
              {/* SMV/OB TABLE TABLE END */}
            </div>
          </div>
          <table>
            <tbody>
              <tr>
                <td className="label-text text-left">Fabric</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.fabric}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Trim</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.trims}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">
                  Embellishment & Embroidery
                </td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.embelishmentAndEmbroidery}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Pattern</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.pattern}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Cutting</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.cutting}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">
                  Makeup / Sewing / Construction
                </td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.makeupOrsewingOrconstruction}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Safety</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.safety}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Additional Information</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.additionalInfo}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Washing</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.washing}</p>
                </td>
              </tr>
              <tr>
                <td className="label-text text-left">Machinery</td>
              </tr>
              <tr>
                <td className="bb-p centerTextOnly">
                  <p>{technicalData.machinery}</p>
                </td>
              </tr>
            </tbody>
          </table>
          {/* DISPATCH'S INFO TABLE END */}
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/technicalIssues/printTechnical.js